<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'register-step-1-content'">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="pageTitle" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16">
                    <div class="p-x-20 m-d-16">
                        <SOStep :step="3" :total="3" v-if="!isUpdate" />
                        <div v-if="isUpdate" class="d-flex f-12 f-c-midgrey f-regular" style="align-items: baseline;">
                            <div class="no-telp">
                                <IconBased width="14" height="14">
                                    <template v-slot:icons>
                                        <WhatsappIconMini clr-fill="#6F7287" />
                                    </template>
                                </IconBased>
                                <span class="m-l-4">+{{ dataDevice.country_code }}{{ dataDevice.nomor }}</span>
                            </div>
                            <label>{{ dataDevice.nama }}</label>
                        </div>
                        <div class="ringkasan f-c-black f-regular f-16 p-x-16 p-y-16 m-d-16">
                            <p class="m-d-16">Ringkasan</p>
                            <div class="step-1 m-d-16" v-if="!isUpdate">
                                <p class="m-d-0 d-flex-between-center">
                                    <span>Registrasi nomor</span>
                                    <label class="m-d-0">
                                        <span :class="{ 'cross-through': isFreeReg }">
                                            {{ priceRegister | currency }}
                                        </span>
                                        <span class="f-c-red" v-if="isFreeReg">(Gratis)</span>
                                    </label>
                                </p>
                                <p class="m-d-0 f-14 f-c-midgrey">+62 {{ registered.nomor }}</p>
                                <p class="m-d-0 f-14 f-c-midgrey">{{ registered.nama }}</p>
                            </div>
                            <div class="step-2 m-d-16">
                                <p class="m-d-0 d-flex-between-center">
                                    <span class="nama-paket" v-if="selectedPaket">
                                        {{ selectedPaket.nama }}
                                    </span>
                                    <span v-if="selectedPaket">{{ selectedPaket.harga | currency }}</span>
                                </p>
                                <p class="m-d-0 f-14 f-c-midgrey" v-if="selectedPaket">
                                    Kuota {{ selectedPaket.quota }} pesan / {{ selectedPaket.masa_aktif }} hari
                                </p>
                                <div class="f-12 f-semi f-c-midgrey auto-update" v-if="registered.auto_renewal === 1">
                                    DIPERPANJANG OTOMATIS
                                </div>
                            </div>
                            <div class="note m-d-16" v-if="registered.auto_renewal === 1">
                                <p class="m-d-0 f-12 f-c-midgrey">
                                    Perpanjangan otomatis dilakukan ketika masa kuota berakhir & ditagih dengan memotong
                                    saldo M-Coin.
                                </p>
                                <p class="m-d-0 f-c-blue f-12" @click="showDetail">Lihat selengkapnya</p>
                            </div>
                            <div class="m-d-16 diskon-voucher">
                                <p class="m-d-0 d-flex-between-center">
                                    <span class="nama-paket" v-if="voucher.Kode">
                                      Kupon  {{ voucher.Kode }}
                                    </span>

                                    <span v-if="voucher.Kode" class="f-c-red" >-{{ getDiskonRupiah | currency }}</span>
                                </p>
                                <div class="f-12 f-semi f-c-midgrey diskon-percent" v-if="voucher.Kode">
                                    POTONGAN {{ voucher.DiskonFitur }}%
                                    <i v-if="voucher.MaxDiskonFitur">Maksimal {{voucher.MaxDiskonFitur | currency}} </i>
                                </div>
                            </div>
                            <div class="total-pembayaran">
                                <p class="m-d-0 d-flex-between-center">
                                    <span>Total pembayaran</span
                                    ><span v-if="selectedPaket">{{ totalBayar | currency }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="m-d-16">
                            <SOInputSelect
                                title="Lokasi Biaya Diakui di Outlet"
                                :required="true"
                                placeholder="Sena Laundry"
                                :options="listOutlet"
                                @option-selected="(v) => (registered.idoutlet = v)"
                                :selected="registered.idoutlet"
                            />
                            <span class="f-12 f-c-midgrey">
                                Akan dicatat sebagai biaya jika anda sudah mengaktifkan integrasi M-Coin
                            </span>
                        </div>
                        <div>
                             <SOInputVoucher
                                title="Kode kupon (opsional)"
                                placeholder="Masukkan kode promo..."
                                :callback-search="getVoucher"
                                :is-validate="validate"
                                :msg-voucher="msgVoucher"
                                :is-fetching="isFetching"
                                :value="getKodeVoucher"
                                @input="onInput($event, 'kode_kupon')"
                            />
                        </div>
                    </div>
                    <div class="separator m-d-16"></div>
                    <div class="p-x-20">
                        <p class="f-16 f-c-black f-bold">
                            Metode pembayaran
                        </p>
                        <div
                            class="m-d-16"
                            v-for="(list, idx) in getMetodeBayar"
                            :key="`${idx}-metode-bayar`"
                            :class="{ selected: isSelected(list), unSelect: !isSelected(list) }"
                        >
                            <SOSlotCard :id="`card-${idx}-metode-bayar`">
                                <template v-slot:card_body>
                                    <div class="d-grid-12 f-14" @click="doSelect(list)">
                                        <div class="grid-cspan-10 m-d-0 f-16 f-c-black f-semi">
                                            {{ list.title }}
                                        </div>
                                        <div class="grid-cspan-2 d-flex" style="justify-content: flex-end;">
                                            <IconBased width="16" height="16" v-if="isSelected(list)">
                                                <template v-slot:icons>
                                                    <RadioCheckedBlue />
                                                </template>
                                            </IconBased>
                                            <IconBased width="16" height="16" v-if="!isSelected(list)">
                                                <template v-slot:icons>
                                                    <RadioUnChecked />
                                                </template>
                                            </IconBased>
                                        </div>
                                        <div class="grid-cspan-12" v-if="getDataMCoin.jumlah">
                                            {{ list.subtitle }}&nbsp;
                                            <span v-if="list.id === '1' && getDataMCoin.jumlah">
                                                {{
                                                    getDataMCoin.jumlah.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                                                }}
                                            </span>
                                        </div>
                                        <div class="grid-cspan-12" v-else>
                                            Saldo M-coin habis
                                        </div>
                                    </div>
                                </template>
                            </SOSlotCard>
                        </div>
                        <div class="total-pembayarans">
                            <p class="m-d-0 d-flex-between-center " v-if="totalBayar>0">
                                    <span>saldo akan dikurangi</span
                                    ><span v-if="selectedPaket">{{ totalBayar | currency }}</span>
                            </p>
                            <p class="m-d-0 d-flex-between-center " v-else>
                                    <span>saldo tidak akan dikurangi karena </span>
                                <span class="f-c-red">(Gratis)</span>

                            </p>

                        </div>

                        <SOButton :primary="true" :full="true" :text="(totalBayar>0) ? 'Bayar' : 'Daftar Gratis'" :id="`next-bayar`" @action="nextStep" :disable="isFetching" />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import SOStep from "@/so-components/global/ui/SOStep.vue";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import SOInputVoucher from "../components/SOInputVoucher.vue";

import IconBased from "../components/iconPack/IconBased.vue";
import RadioCheckedBlue from "../components/iconPack/RadioCheckedBlue1616.vue";
import RadioUnChecked from "../components/iconPack/RadioUnChecked1616.vue";
import WhatsappIconMini from "../components/iconPack/WhatsappIcon1414.vue";

import { required } from "vuelidate/lib/validators";
import { moduleName } from "../store/state";
import metodeBayar from "../static/metodeBayar";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
    name: "RegisterStep3",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOButton,
        SOStep,
        SOSlotCard,
        SOInputVoucher,
        IconBased,
        RadioCheckedBlue,
        RadioUnChecked,
        WhatsappIconMini,
        SOInputSelect,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "wa_autosender.detail_perangkat.ubah_paket_2") {
                vm.setUpdate(true);
                vm.setBackLink("wa_autosender.detail_perangkat.ubah_paket_1");
            } else {
                if (!vm.isDoneStep1) {
                    vm.back();
                }
            }

            if (from.name === "wa_autosender.register.confirm") {
                document.getElementById("next-bayar").scrollIntoView();
            }
        });
    },
    data() {
        return {
            backLink: "wa_autosender.register.step2",
            msgVoucher: "",
            validate: null,
            isUpdate: false,
            selected: {},
            listOutlet: [],
        };
    },
    mounted() {
        this.init();
        this.smartTrackingView("add_perangkat_whatsapp_step3");

    },
    watch: {
        response: function(newRes, oldRes) {
            let newMsg = newRes.msg ? newRes.msg : newRes.err;
            let oldMsg = oldRes.msg ? oldRes.msg : oldRes.err;
            // let isNotif = newMsg && newMsg.indexOf("oucher") !== -1 ? true : false;
            let isNotif =false
            if(!newRes.status){
                isNotif=true
            }
            if (newMsg !== oldMsg && isNotif) {
                this.msgVoucher = newMsg;
                this.validate = newRes.success;
            }
        },
        selected: function(newVal, oldVal) {
            console.log(this.selected)
            if (newVal.id !== oldVal.id) {
                setTimeout(() => {
                    this.setCssSelected();
                }, 50);
            }
        },
    },
    validations: {
        registered: {
            jenis_pembayaran: {
                required,
            },
            idoutlet: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            isFetching: "isFetching",
            response: "response",
            registered: "registered",
            isFreeReg: "isFreeReg",
            paketWhatsapp: "paketWhatsapp",
            voucher: "voucher",
        }),
        ...mapGetters("metaModule", {
            getDataMCoin: "getDataMCoin",
        }),
        isDoneStep1() {
            let { nomor, nama, id_paket } = this.registered;
            return nomor && nama && id_paket ? true : false;
        },
        priceRegister() {
            return this.registered.price;
        },
        totalHarga() {
            return this.isFreeReg ? this.selectedPaket.harga : this.selectedPaket.harga + this.priceRegister;
        },
        hrgPaket() {
            return this.selectedPaket.harga;
        },
        totalBayar() {
            let total = this.totalHarga;
            if (this.isUpdate) {
                total = this.hrgPaket;
            }
            return Math.round(total - this.getDiskonRupiah);
        },
        getDiskonRupiah() {
            let { DiskonFitur,MaxDiskonFitur } = this.voucher;
            let total = this.totalHarga;
            if (this.isUpdate) {
                total = this.hrgPaket;
            }
            let diskonRupiah= DiskonFitur ? (total * DiskonFitur) / 100 : 0;
            if(diskonRupiah>MaxDiskonFitur){
                diskonRupiah = MaxDiskonFitur
            }
            return diskonRupiah
        },
        getKodeVoucher() {
            return this.registered.kode_kupon;
        },
        getMetodeBayar() {
            return metodeBayar;
        },
        isSelected() {
            return (list) => {
                return this.registered.jenis_pembayaran === list.id;
            };
        },
        selectedPaket() {
            let { id_paket } = this.registered;

            return this.paketWhatsapp.find((wa) => wa.id === id_paket);
        },
        qTitle() {
            return this.$route.query?.customTitle || "Ubah paket";
        },
        pageTitle() {
            return this.isUpdate ? this.qTitle : "Registrasi WA Autosender";
        },
    },
    methods: {
        ...mapActions({
            getVoucher: `${moduleName}/getVoucher`,
            setRegistered: `${moduleName}/setRegistered`,
            setVoucher: `${moduleName}/setVoucher`,
            resetResponse: `${moduleName}/resetResponse`,
            fetchDataMCoin: `metaModule/fetchDataMCoin`,
            getListPaket: `${moduleName}/getListPaket`,
        }),
        showDetail() {
            this.$router.push({ name: "wa_autosender.register.detail_info_step_3" });
        },
        setBackLink(val) {
            this.backLink = val;
        },
        setUpdate(val) {
            this.isUpdate = val;
        },
        init() {
            this.getOutlet();
            this.fetchDataMCoin();
            if (this.paketWhatsapp.length === 0) {
                this.getListPaket();
            }
        },
        back() {
            this.$router.push({ name: this.backLink, query: this.$route.query });
        },
        onInput(val, key) {
            this.setRegistered({ key, val });
            if (!val) {
                this.setVoucher({});
                this.msgVoucher = "";
                this.validate = null;
                this.resetResponse();
            }
        },
        showDetail() {
            this.$router.push({ name: "wa_autosender.register.detail_info_step_3" });
        },
        setCssSelected() {
            let elSelected = document.getElementsByClassName("selected");
            let elUnselect = document.getElementsByClassName("unSelect");

            if (elSelected) {
                elSelected[0].firstChild.firstChild.style.backgroundColor = "#edf5ff";
                elSelected[0].firstChild.firstChild.style.borderColor = "#206CFF";
            }

            if (elUnselect) {
                elUnselect.forEach((element) => {
                    element.firstChild.firstChild.style.backgroundColor = "#ffffff";
                    element.firstChild.firstChild.style.borderColor = "#c8d0dd";
                });
            }
        },
        doSelect(val) {
            this.selected = val;
            this.setRegistered({ key: "jenis_pembayaran", val: val.id });
        },
        isValid() {
            console.log(this.$v.registered.$touch());
            let { jenis_pembayaran } = this.$v.registered;
            jenis_pembayaran.$touch();

            return jenis_pembayaran.$invalid;
        },
        isValidOutlet() {
            let { idoutlet } = this.$v.registered;
            idoutlet.$touch();

            return idoutlet.$invalid;
        },
        isValidVOucher() {
            let valid = true;
            if (this.getKodeVoucher && !this.voucher.id) {
                valid = false;
            }
            return valid;
        },
        nextStep() {
            if (!this.isValidVOucher()) {
                this.$toast.error("Kode voucher tidak dapat digunakan, hapus dulu kode voucher untuk melanjutkan");
                return;
            }

            if (this.isValid()) {
                this.$toast.error("Mohon pilih metode pembayaran terlebih dahulu");
                return;
            }

            if (this.isValidOutlet()) {
                this.$toast.error("Mohon pilih Outlet terleih dahulu");
                return;
            }

            let goto = "wa_autosender.register.confirm";
            if (this.isUpdate) {
                goto = "wa_autosender.detail_perangkat.ubah_paket_confirm";
            }
            this.$router.push({ name: goto, query: this.$route.query });
            this.smartTrackingClick("bayar_perangkat_whatsapp");

        },
        async getOutlet() {
            try {
                const res = await this.$store.dispatch("outletModule/fetchOutletAll");
                this.listOutlet = res.data.map(value => {
                    return {
                        telp: value.telp,
                        id: value.idoutlet,
                        text: value.nama
                    }
                });
            } catch (error) {
                this.$toas.error(error)
            }
        },
    },
};
</script>
<style scoped>
.ringkasan {
    border: 1px solid #c8d0dd;
    border-radius: 8px;
}
.total-pembayaran {
    border-top: 1px solid #ededed;
}
.module-wa-autosender .step-2 .d-flex-between-center {
    align-items: unset;
}
.nama-paket {
    max-width: 150px;
}
.diskon-percent,
.auto-update {
    padding: 2px 8px;
    border-radius: 25px;
    background-color: #ededed;
    width: fit-content;
}
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}
.cross-through {
    text-decoration: line-through;
    color: red;
}
@media (min-width: 320px) {
    .nama-paket {
        max-width: 140px;
    }
}
@media (min-width: 400px) {
    .nama-paket {
        max-width: 220px;
    }
}
@media (min-width: 450px) {
    .nama-paket {
        max-width: 270px;
    }
}
</style>
